import React from 'react';
import PropTypes from 'prop-types';
import { log } from '_shared/errors/log';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    log({
      level: 'ERROR',
      message: `Collection Client Error has occured | ${error} | ${errorInfo.componentStack}`
    });
  }

  render() {
    if (this.state.hasError) {
      return this.props.renderError();
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  renderError: PropTypes.func.isRequired,
  children: PropTypes.node
};
